import {
    AttentionIcon,
    Box,
    Button,
    Center,
    Heading,
    Stack,
} from '@adamdotai/design-system'
import { captureException } from '@sentry/nextjs'
import { useTranslations } from 'next-intl'
import { useEffect } from 'react'

type PageErrorBoundaryFallbackProps = {
    ShowErrorIcon?: boolean
    reset?: () => void
    error: unknown
}

export function PageErrorBoundaryFallback({
    ShowErrorIcon = true,
    reset,
    error,
}: PageErrorBoundaryFallbackProps) {
    const t = useTranslations()

    useEffect(() => {
        captureException(error)
    }, [error])

    return (
        <Center h="full" minH="100" p={10}>
            <Stack spacing={10} align="center">
                {ShowErrorIcon && (
                    <Box
                        p="8"
                        bg="neutral.300"
                        borderRadius="50%"
                        outline={'16px solid '}
                        outlineColor="#F7F7F9"
                    >
                        <AttentionIcon size="lg" />
                    </Box>
                )}
                <Stack
                    spacing={5}
                    align="center"
                    textAlign={'center'}
                    paddingX={4}
                >
                    <Heading size="h5">
                        {t('common.this-not-looking-for')}
                    </Heading>
                    <Heading
                        color="neutral.1400"
                        size="headline"
                        textAlign="center"
                    >
                        {t('common.error-msg')}
                    </Heading>
                    <Button
                        variant="outline"
                        colorScheme="primary"
                        onClick={reset}
                    >
                        {t('common.reload')}
                    </Button>
                </Stack>
            </Stack>
        </Center>
    )
}
